import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateShiftEntity } from '../../domain/entities/CreateUpdateShift'
import moment from 'moment'

export class CreateUpdateShiftModel extends CreateUpdateShiftEntity {
  startTime?: string
  regionId?: number
  constructor(dataDto: CreateUpdateShiftEntity) {
    super()
    mapEntityProperties<CreateUpdateShiftModel>(this, dataDto, {
      exclude: ['region'],
      map: {
        regionId: dataDto.region?.id,
        duration:
          dataDto.duration && /^\d{2}:\d{2}:00$/.test(dataDto.duration)
            ? dataDto.duration
            : moment(dataDto.duration).format('HH:mm:00')
      }
    })
  }
}
